import * as d3 from "d3"
import * as topojson from "topojson"
import moment from "moment"

var interval = null;
var firstRun = true;
var currentDate = null;

function makeMap(states, data, places, labels) {

	var statusMessage = d3.select("#statusMessage");
	var width = document.querySelector("#mapContainer").getBoundingClientRect().width
	var height = width * 0.6
	var mobile = false;

	if (width < 881) {
	    height = width * 0.8;
	    mobile = true;
	}
	var margin = {top: 0, right: 0, bottom: 0, left:0}
	var active = d3.select(null);
	var scaleFactor = width / 860

	var projection = d3.geoMercator()
	                .scale(1)
	                .translate([0,0])         
	var imageObj = new Image()
	imageObj.src = 'https://interactive.guim.co.uk/embed/iframeable/2019/10/drought-map-iframe/html/assets/aus-crop-light.png'

	// console.log(sa2s.objects.sa2s
	   
	
	d3.select("#mapContainer svg").remove();

	var keyWidth = 110
	var keyHeight = 100

	if (width < 450) {
		keyWidth = 110
		keyHeight = 70
	}

	var svg = d3.select("#mapContainer").append("svg")	
	                .attr("width", width)
	                .attr("height", height)
	                .attr("id", "map")
	                .attr("overflow", "hidden");                                      

	// context.clearRect(0, 0, width, height);

	var path = d3.geoPath()
	    .projection(projection);

	var bounds = path.bounds(topojson.feature(states,states.objects.states));

	var mapScale = 1 / Math.max(
	    (bounds[1][0] - bounds[0][0]) / width,
	    (bounds[1][1] - bounds[0][1]) / height);

	var translation = [
	    (width - mapScale * (bounds[1][0] + bounds[0][0])) / 2,
	    (height - mapScale * (bounds[1][1] + bounds[0][1])) / 2];

	projection
		.scale(mapScale)
		.translate(translation);

	var raster_width = (bounds[1][0] - bounds[0][0]) * mapScale;
	var raster_height = (bounds[1][1] - bounds[0][1]) * mapScale;

	var rtranslate_x = (width - raster_width) / 2;
	var rtranslate_y = (height - raster_height) / 2;	       

	var graticule = d3.geoGraticule();  

	labels.forEach( function(d) {
		d.lat = +d.lat;
		d.lon = +d.lon;
	})

	var filterPlaces = places.features.filter(function(d){ 
		if (mobile) {
			return d.properties.scalerank < 2	
		}

		else {
			return d.properties.scalerank < 2		
		}
		
	});
	// console.log(filterPlaces);

	function drawMap() {
		svg.append("image")
	        .attr('id', 'Raster')
	        .attr("xlink:href", 'https://interactive.guim.co.uk/embed/iframeable/2019/10/drought-map-iframe/html/assets/aus-crop-light.png')
	        .attr("class", "raster")
	        .attr("width", raster_width)
	        .attr("height", raster_height)
	        .attr("transform", "translate(" + rtranslate_x + ", " + rtranslate_y + ")");        

	    svg.append("g")
		    .selectAll("path")
		    .data(topojson.feature(states,states.objects.states).features)
		    .enter().append("path")
		        .attr("class", "sa2")
		        .attr("id", d => "sa2" + d.properties.name)
		        .attr("fill", "none")
		        .attr("stroke", "#bcbcbc")
		        .attr("data-tooltip","")
		        .attr("d", path);    

		svg.append("g")
		    .selectAll("path")
		    .data(topojson.feature(data,data.objects.drought).features)
		    .enter().append("path")
		        .attr("class", "sa2")
		        .attr("fill", function(d) {
		        	if (d.properties.DN == 1) {
		        		return "#d7301f"
		        	}

		        	else if (d.properties.DN == 2) {
		        		return "#fc8d59"
		        	}

		        	else if (d.properties.DN == 3) {
		        		return "#fdcc8a"
		        	}
		        })
		        .attr("stroke", "none")
		        .style("opacity",0.7)
		        .attr("d", path);    		       

		// var labelContainers = svg.selectAll(".labelContainers")
		// 	.data(labels).enter().append("g")
		// 		.attr("class", "labelContainers")
		// 		.attr("transform", function(d) { return "translate(" + projection([d.lon,d.lat]) + ")"; })    

		// if (width < 500) {
		// 	labelContainers
		// 		.append("circle")
		// 		.attr("class","labelircle")
		// 	    .attr("r", 2)

		// 	labelContainers
		// 		.append("text")
		// 		.attr("class", "labelText")
		// 		.attr("dy", -5)
		// 		.attr("text-anchor","middle")
		// 		.text(function(d) { return d['name']})   
		// }

		// else {
		// 	labelContainers
		// 	.append("circle")
		// 	.attr("class","labelircle")
		//     .attr("r", 2)	

		// labelContainers
		// 	.append("text")
		// 	.attr("class", "labelText")
		// 	.attr("dx", 5)
		// 	.attr("dy", 5)
		// 	.text(function(d) { return d['name']})  
		// }

		var placeContainers = svg.selectAll(".placeContainers")
					.data(filterPlaces)
					.enter().append("g")
						.attr("class", "placeContainers")
						.attr("transform", function(d) { return "translate(" + projection(d.geometry.coordinates) + ")"; })		

		// placeContainers
		// 	.append("circle")
		// 	.attr("class","placeCircle")
		//     .attr("r", 2)

		placeContainers
			.append("text")
			.attr("class", "placeText")
			.attr("dy", 5)
			.attr("fill","#767676")
			.text(function(d) { return d['properties']['name']})        
	}



	drawMap();
	      
	// var colorPurpose = d3.scaleOrdinal()
	// 			.domain(['exploration', 'appraisal/pilot', 'development/production', 'other'])
	// 			.range(["rgba(250, 135, 117,0.8)",
	// 					"rgba(205, 52, 181,0.8)",
	// 					"rgba(0, 0, 255,0.8)",
	// 					"rgba(118, 118, 118, 0.8)"]);
	
	// var colorStatus = d3.scaleOrdinal()
	// 			.domain(["plugged and abandoned","suspended/capped/shut-in","producing","water bore","unknown"])
	// 			.range(["rgba(255,164,116,0.8)",
	// 					"rgba(244,116,97,0.8)",
	// 					"rgba(139,0,0,0.8)",
	// 					"rgba(118, 118, 118, 0.8)",
	// 					"rgba(118, 118, 118, 0.8)"]);


	function sortData(sortBy) {
		data.sort(function(a, b){
   			return d3.descending(a["sort_" + sortBy], b["sort_" + sortBy]);
		})
	}

	statusMessage.transition(600).style("opacity",0);

	var animationSpeed = 25


	firstRun = false
	// var interval = d3.interval(animate, 200);

}


Promise.all([
	d3.json('https://interactive.guim.co.uk/embed/iframeable/2019/10/drought-map-iframe/html/assets/au-states.json'),
	d3.json('https://interactive.guim.co.uk/embed/iframeable/2019/10/drought-map-iframe/html/assets/drought-clipped-coded.json'),
	d3.json('https://interactive.guim.co.uk/embed/iframeable/2019/10/drought-map-iframe/html/assets/places.json'),
	d3.csv('https://interactive.guim.co.uk/embed/iframeable/2019/10/drought-map-iframe/html/assets/labels.csv')
])
.then((results) =>  {
	makeMap(results[0],results[1],results[2],results[3])

	var to=null
	var lastWidth = document.querySelector("#mapContainer").getBoundingClientRect()
	window.addEventListener('resize', function() {

		var thisWidth = document.querySelector("#mapContainer").getBoundingClientRect()
		if (lastWidth != thisWidth) {
			
			window.clearTimeout(to);
			to = window.setTimeout(function() {
				    makeMap(results[0],results[1],results[2],results[3])
				}, 100)
		}
			
	})

});